import { bind, Component, h, tag } from "omi";

import { NWCloseButton } from "@/components/atoms/nw-button/closeButton";
import { NavStore, NavView } from "@/components/nw-nav/store";
import { NWAuthManager } from "@/components/nw-auth-manager";
import { addToClipboard } from "@/utils/clipboard";
import { NWIcon, NWTooltip } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import { NavSection } from "./navSection";

type Props = {};

@tag("nav-layout")
export class NavLayout extends Component<Props> {
  static css = [tailwind];

  @bind
  private async handleInviteCopy() {
    const inviteLink = "https://link.nextwork.org/app?utm_source=app&utm_medium=nav&utm_campaign=referral";
    await addToClipboard(inviteLink);

    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackInviteLinkCopied("user-menu");
    });
  }

  render() {
    const showReferral = NavStore.view.value === NavView.TRACK_OVERVIEW;

    return (
      <div class="h-full overscroll-none pointer-events-auto shadow-md rounded-xl bg-white p-6 flex items-start flex-col shrink-0 border border-gray-200">
        <div class="inline-flex items-center justify-between w-full mb-3">
          <NWAuthManager withUI={true} />
          <NWCloseButton size="md" onClick={() => Store.app.toggleNav(false, "close-btn")} />
        </div>

        <div class="space-y-2 w-full h-full overflow-y-auto hide-scrollbar overscroll-contain py-1" tabIndex={-1}>
          <slot></slot>
        </div>

        {showReferral && (
          <div class="animate-slideInRightFast w-full">
            <NavSection withBottomMargin={false}>
              <NWTooltip placement="top" content="Copied! Send to a friend 🚀" trigger="click">
                <button
                  tabIndex={0}
                  type="button"
                  class="flex items-center justify-between w-full p-3 text-secondary hover:bg-gray-100 rounded-md transition-all"
                  onClick={this.handleInviteCopy}
                >
                  <div class="inline-flex space-x-4 w-full animate-fadeInFast">
                    <div class="shrink-0">
                      <NWIcon name="heart-hand" width={24} height={24} />
                    </div>
                    <h4 class="truncate pr-4">Invite a friend</h4>
                  </div>
                </button>
              </NWTooltip>
            </NavSection>
          </div>
        )}
      </div>
    );
  }
}
